import { __assign } from "tslib";
export { DEFAULT_BREAKPOINTS } from './constants';
export var adjustBreakpointHeight = function (breakpoints, heightDelta) {
    return breakpoints.map(function (point) { return (__assign(__assign({}, point), { elementHeight: point.elementHeight + heightDelta })); });
};
export var createGridBreakpoint = function (_a) {
    var maxWidth = _a.screenWidth, containerWidth = _a.containerWidth, elementSpacing = _a.elementSpacing, elementHeight = _a.elementHeight, elementsPerRow = _a.elementsPerRow;
    return ({
        maxWidth: maxWidth,
        elementWidth: (containerWidth + elementSpacing) / (elementsPerRow + elementSpacing) -
            elementSpacing,
        elementHeight: elementHeight,
    });
};
//# sourceMappingURL=breakpoints.js.map